<h4 class="font-bold" style="font-size: 18px">
  {{ "settings.userRights" | translate }}
</h4>
<p-tabs [value]="activeIndex" (valueChange)="onTabChange($event)">
  <p-tablist>
    <p-tab [value]="0">{{ 'settings.users' | translate }}</p-tab>
  </p-tablist>

  <p-tabpanels>
    <p-tabpanel [value]="0">
      <div class="grid">
        <div class="col-12 grid">
          <div class="col-4">
            <p-iconField iconPosition="left" class="w-full">
              <p-inputIcon styleClass="pi pi-search" />
              <input
                type="text"
                pInputText
                (keydown.enter)="filterGlobal($event)"
                placeholder="{{ 'settings.searchUser' | translate }}"
              />
            </p-iconField>
          </div>
          <div class="col-8 text-right">
            <p-button [outlined]="true" (click)="openFilterModal()">
              <i class="pi pi-filter"></i>
              @if (tags.length > 0) {
                <p-badge [value]="tags.length" severity="info" class="flex align-content-center filter-badge" />
              }
              <span class="pl-2 font-semibold">{{ 'global.filter' | translate }}</span>
            </p-button>
          </div>
          @if (tags.length > 0) {
            @for (tag of tags; track $index) {
              <p-tag class="ml-3 mb-1">
                <span>{{ tag.header | translate }}{{ ": " }}
                  @if (!tag.isMultiple) {
                    @if (tag.isLengthOnly) {
                      {{ tag.valueString }} {{ 'global.selectedElements' | translate }}
                    } @else {
                      {{ tag.valueString | translate }}
                    }
                  } @else {
                    @for (item of tag.valueString; track $index) {
                      {{ item | translate }}{{ $index < tag.valueString.length - 1 ? ', ' : '' }}
                    }
                  }
                </span>
                <i class="pi pi-times-circle ml-1 cursor-pointer" (click)="removeFilter(tag.name, tag.parent)"></i>
              </p-tag>
            }
            <span style="color: #aaa" class="pl-3 flex align-items-center cursor-pointer underline"
              (click)="resetFilters()">
              {{ 'global.removeFilter' | translate }}
            </span>
          }
        </div>

        @if (selectedUsers.length > 0) {
          <div class="col-12 flex align-items-center"
            *ngxPermissionsOnly="['PERMISSION_MANAGE_ROLES_AND_USERS', 'PERMISSION_MANAGE_USERS', 'PERMISSION_SUPER_ADMIN']">
            {{ selectAll ? totalRecords : selectedUsers.length }}
            @if(selectedUsers.length > 1) {
              <span class="pl-1">{{ "settings.usersSelected" | translate }}</span>
            } @else {
              <span class="pl-1">{{ "settings.userSelected" | translate }}</span>
            }
            <p-button [text]="true" (click)="selectAllUsers()" label="{{ 'buttons.selectAll' | translate }}" />
            <p-button [text]="true" severity="danger" (click)="removeSelection()" label="{{ 'buttons.removeSelection' | translate }}" />
            <p-button [text]="true" (click)="openEditRoleDialog()" icon="pi pi-file-edit font-semibold" label="{{ 'buttons.edit' | translate }}" />
            <p-button [text]="true" (click)="exportUsers()" [disabled]="disabledExportButton" icon="pi pi-upload font-semibold" label="{{ 'buttons.export' | translate }}" />
          </div>
        }
      </div>

      <div>
        @if(isOperatorAdmin() || isSeller() || isSuperAdmin()) {
          <div *ngxPermissionsOnly="['PERMISSION_MANAGE_ROLES_AND_USERS', 'PERMISSION_MANAGE_USERS', 'PERMISSION_SUPER_ADMIN']">
            <p-table
              #table
              class="table-shadow"
              [value]="users"
              [scrollable]="true"
              selectionMode="single"
              [(selection)]="selectedUsers"
              [rowHover]="true"
              scrollHeight="calc(100vh - 300px)"
              [paginator]="true"
              [rows]="rows"
              [lazy]="true"
              (onLazyLoad)="onLazyLoad($event)"
              [loading]="loading"
              (selectionChange)="onSelectionChange($event)"
              [showCurrentPageReport]="true"
              [currentPageReportTemplate]="'table.currentPageReportTemplate' | translate"
              [rowsPerPageOptions]="[5, 50, 100, 200]"
              [totalRecords]="totalRecords"
              [selectionPageOnly]="true"
              [tableStyle]="{ 'min-width': '50rem' }">
              <ng-template #header>
                <tr>
                  <th class="w-4rem" id="table-checkbox">
                    <p-tableHeaderCheckbox />
                  </th>
                  @for (header of headers; track $index) {
                    @if (!header.hidden) {
                      @if (header.sort == false) {
                        <th [id]="header.field">
                          <span class="font-semibold">{{ header.header | translate }}</span>
                        </th>
                      } @else {
                        <th [pSortableColumn]="header.sortField || header.field" [id]="header.field">
                          <span class="font-semibold">{{ header.header | translate }}</span>
                          <p-sortIcon [field]="header.field" class="ml-1"/>
                        </th>
                      }
                    }
                  }
                </tr>
              </ng-template>
              <ng-template #body let-user>
                <tr>
                  <td><p-tableCheckbox [value]="user" /></td>
                  @for (header of headers; track $index) {
                    @if (!header.hidden) {
                      <td>
                        @if (header.field.indexOf(".") > -1) {
                          {{ user[header.field.split(".")[0]][header.field.split(".")[1]] }}
                        } @else if (header.type == "tag") {
                          <p-tag [severity]="getSeverity(user[header.field])" value="{{ user[header.field] | translate }}"></p-tag>
                        } @else if (header.type == "list") {
                          @for (item of user[header.field]; track $index) {
                            <div>{{ item[header.listField] }}</div>
                          }
                        } @else {
                          {{ user[header.field] }}
                        }
                      </td>
                    }
                  }
                </tr>
              </ng-template>
            </p-table>
          </div>
        } @else {
          <div *ngxPermissionsOnly="['PERMISSION_MANAGE_ROLES_AND_USERS_RESTRICTED']" class="mt-3">
            <p-table
              #table
              class="table-shadow"
              [value]="users"
              [scrollable]="true"
              [rowHover]="true"
              scrollHeight="calc(100vh - 300px)"
              [paginator]="true"
              [rows]="rows"
              [lazy]="true"
              (onLazyLoad)="onLazyLoad($event)"
              [loading]="loading"
              [showCurrentPageReport]="true"
              [currentPageReportTemplate]="'table.currentPageReportTemplate' | translate"
              [rowsPerPageOptions]="[5, 50, 100, 200]"
              [totalRecords]="totalRecords"
              [selectionPageOnly]="true"
              [tableStyle]="{ 'min-width': '50rem' }">
              <ng-template #header>
                <tr>
                  @for (header of headers; track $index) {
                    @if (!header.hidden) {
                      @if (header.sort == false) {
                        <th [id]="header.field">
                          <span class="font-semibold">{{ header.header | translate }}</span>
                        </th>
                      } @else {
                        <th [pSortableColumn]="header.sortField || header.field" [id]="header.field">
                          <span class="font-semibold">{{ header.header | translate }}</span>
                          <p-sortIcon [field]="header.field" class="ml-1"/>
                        </th>
                      }
                    }
                  }
                </tr>
              </ng-template>
              <ng-template #body let-user>
                <tr>
                  @for (header of headers; track $index) {
                    @if (!header.hidden) {
                      <td>
                        @if (header.field.indexOf(".") > -1) {
                          {{ user[header.field.split(".")[0]][header.field.split(".")[1]] }}
                        } @else if (header.type == "tag") {
                          <p-tag [severity]="getSeverity(user[header.field])" value="{{ user[header.field] | translate }}"></p-tag>
                        } @else if (header.type == "list") {
                          @for (item of user[header.field]; track $index) {
                            <div>{{ item[header.listField] }}</div>
                          }
                        } @else {
                          {{ user[header.field] }}
                        }
                      </td>
                    }
                  }
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </div>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
<p-dialog
  header="{{ 'settings.editOfRole' | translate }}"
  [modal]="true"
  [(visible)]="editRoleDialogVisible"
  [style]="{ width: '70rem', height: '50rem' }"
>
  <ng-template pTemplate="header">
    <div class="inline-flex align-items-center justify-content-center gap-2">
      <i class="pi pi-file-edit text-lg"></i>
      <span class="font-bold white-space-nowrap text-lg">{{
        "settings.editOfRole" | translate
      }}</span>
    </div>
  </ng-template>
  <div class="role-modal">
    <div class="p-1 flex flex-column align-items-center pt-5 warn">
      <span class="font-semibold">
        {{ selectAll ? totalRecords : selectedUsers.length }}
        @if(selectedUsers.length > 1) {
          <span>{{ "settings.usersSelected" | translate }}</span>
        }@else {
          <span>{{ "settings.userSelected" | translate }}</span>
        }
       
        
      </span>
      <span class="flex">
        <i class="pr-2">
          <svg
            viewBox="64 64 896 896"
            focusable="false"
            fill="currentColor"
            width="1.25em"
            height="1.25em"
            data-icon="warning"
            aria-hidden="true"
          >
            <path
              d="M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"
              fill="#ff6f00"
            ></path>
            <path
              d="M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z"
              fill="#fff5e6"
            ></path>
            <path
              d="M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z"
              fill="#ff6f00"
            ></path>
          </svg>
        </i>
        <span class="font-italic" style="color: #7e7e7e">{{
          "settings.warningEditRole" | translate
        }}</span>
      </span>
    </div>
    <div class="user-list mt-3" style="min-height: 2rem">
      @if (!selectAll) {
        @for (user of selectedUsers; track $index) {
          <span class="pl-1 mb-1">
            <p-tag>
              {{ user.firstname + " " + user.lastname }}
            </p-tag>
          </span>
        }
      } @else {
        <span>
          {{ "settings.allTheUsersSelected" | translate }}
        </span>
      }
    </div>
    @if(!onlyOperatorsSelected && !onlySellerSelected) {
      <div class="mt-3 mb-2">
        <i class="pi pi-info-circle bg-icon"></i>
        <span class="pl-2" style="font-size: 1rem">{{'settings.OperatorAndSellerSelected' | translate}}</span>
      </div>
    }
    <p-pickList
      [source]="availableRoles"
      [target]="affectedRoles"
      sourceHeader="{{ 'settings.availableRoles' | translate }}"
      targetHeader="{{ 'settings.affectedRoles' | translate }}"
      [dragdrop]="false"
      [responsive]="true"
      (onMoveToTarget)="addRole($event)"
      (onMoveToSource)="removeRole($event)"
      [showSourceControls]="false"
      [showTargetControls]="false"
      breakpoint="700px"
    >
      <ng-template let-role pTemplate="item">
        <div class="flex flex-wrap p-2 align-items-center gap-3">
          <div class="flex-1 flex flex-column gap-2">
            <span class="font-bold">{{ role.roleName }}</span>
          </div>
        </div>
      </ng-template>
    </p-pickList>
     @if (onlyOperatorsSelected) {
      <div class="mt-5">
        <p class="font-bold">{{'shop.associateShopOpTitle' | translate}}</p>
        <p-pickList
        [source]="availableShops"
        [target]="affectedShops"
        sourceHeader="{{ 'settings.availableShops' | translate }}"
        targetHeader="{{ 'settings.affectedShops' | translate }}"
        [dragdrop]="false"
        [responsive]="true"
        (onMoveToTarget)="addShop($event)"
        (onMoveToSource)="removeShop($event)"
        [showSourceControls]="false"
        [showTargetControls]="false"
        breakpoint="700px"
      >
        <ng-template let-shop pTemplate="item">
          <div class="flex flex-wrap p-2 align-items-center gap-3">
            <div class="flex-1 flex flex-column gap-2">
              @if(shop.shopCode ===  constants.EQUIPE_MP_SHOP_CODE_FR || shop.shopCode ===  constants.PREACTIVATION_SHOP_CODE_FR) {
                <span class="font-bold">{{ shop.shopName }} - {{'France' | translate}}</span>
              }@else { 
                <span class="font-bold">{{ shop.shopName }} - {{'Belgique' | translate}}</span>
              }
            </div>
          </div>
        </ng-template>
      </p-pickList>
       <!--  <div class="card flex justify-content-center">
          @if(items.length == 0) {
            <p>{{'shop.NoShopOpMessage' | translate}}</p>
          } @else {
            <p-listbox
            [options]="items"
            [(ngModel)]="selectedItems"
            optionLabel="name"
            [style]="{ width: '15rem' }"
            [multiple]="true"
            checkbox="checkbox"
            [metaKeySelection]="false"
            [listStyle]="{ 'max-height': '220px' }"
            [showToggleAll]="false"
          />
          }
          
         
        </div> -->
      </div>
    }
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2 mt-3">
      <p-button
        label="{{ 'buttons.cancel' | translate }}"
        severity="secondary"
        (onClick)="editRoleDialogVisible = false"
      />
      <p-button
        label="{{ 'buttons.save' | translate }}"
        (click)="affectRoles()"
      />
    </div>
  </ng-template>
</p-dialog>
<p-toast></p-toast>
